export default __webpack_public_path__ + "static/media/Ira-Glass.44bfd95e.jpg";